import { SecurityCheckIcon } from '@hugeicons/core-free-icons';
import cn from 'classnames';
import { Tab, Tabs } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import { IconComponent } from 'components/Icon/IconComponent';
import { TwoFactorAuthenticationSetup } from 'components/TwoFactorAuthenticationSetup/TwoFactorAuthenticationSetup';

import { ChangePassword } from './ChangePassword/ChangePassword';
import styles from './Security.module.scss';

export const Security = ({
  user,
  company,
  setLoading = () => {},
  messagePopUp = () => {},
  onUserUpdate = () => {},
  onEnable2FA = () => {},
  onDisable2FA = () => {},
}) => {
  const { t } = useTranslation();

  return (
    <div className={cn(styles.root)}>
      <div className={cn('card--small', 'card', 'card-with-border')}>
        <div className="u-margin-top--large u-margin-bottom u-margin-x d-flex align-items-start u-gap">
          <IconComponent icon={SecurityCheckIcon} size="large" />
          <div className="d-flex flex-column u-gap-small">
            <div className={cn('u-flex-box', 'u-flex-justify-between', 'u-flex-align-center')}>
              <h1 className="title-2">{t('account.tabs.security.title')}</h1>
            </div>
            <p className="t-small">{t('account.tabs.security.description')}</p>
          </div>
        </div>
        <Tabs defaultActiveKey="password" className="tabs padding-small">
          <Tab eventKey="password" title={t('account.tabs.security.password.title')}>
            <ChangePassword user={user} setLoading={setLoading} messagePopUp={messagePopUp} />
          </Tab>
          <Tab eventKey="2fa" title={t('common.twoFactorAuthenticationTitle')}>
            <TwoFactorAuthenticationSetup
              user={user}
              company={company}
              onEnable2FA={onEnable2FA}
              setLoading={setLoading}
              onUserUpdate={onUserUpdate}
              messagePopUp={messagePopUp}
              onDisable2FA={onDisable2FA}
            />
          </Tab>
        </Tabs>
      </div>
    </div>
  );
};
